import * as Routes from 'constants/Routes'
import { injectReducer } from 'common/reducers'

export default store => ({
  path: Routes.INTEGRATIONS,
  getComponent: async function (nextState, cb) {
    const [module, reducer] = await Promise.all([
      import('./containers/IntegrationsContainer'),
      import('./reducers')
    ])

    injectReducer(store, { key: 'integrations', reducer: reducer.default })

    cb(null, module.default)
  }
})
